<template>
  <div>
    <div v-for="(item, index) in formBody.fields" :key="`${item?.name?.key || index}-${index}`">
      <div class="mb-4" v-if="item.is_visible">

        <label :for="item.name.key">
          {{ item.name.label }}
          <sup v-if="item.require">*</sup>
        </label>

        <!-- Password fields with show/hide -->
        <div v-if="isPasswordField(item)" class="d-flex align-items-center">
          <div class="flex-grow-1">
            <app-input
                :type="passwordVisible[item.name.key] ? 'text' : 'password'"
                :id="item.name.key"
                :required="item.require"
                v-model="formData.fields[index].value"
            />
          </div>

          <button
              type="button"
              class="btn btn-light ml-2"
              style="white-space: nowrap;"
              @click.prevent="togglePasswordVisibility(item.name.key)"
          >
            {{ passwordVisible[item.name.key] ? $t('hide') : $t('show') }}
          </button>
        </div>

        <!-- Normal input -->
        <app-input
            v-else
            :type="item.type"
            :id="item.name.key"
            :list="listGen(item.options, item.type, item)"
            :required="item.require"
            :disabled="isReadonlyField(item)"
            v-model="formData.fields[index].value"
        />

        <!-- mismatch message only if both password fields exist on this step -->
        <small v-if="passwordMismatch" class="text-danger d-block mt-1">
          {{ $t('passwords_do_not_match') }}
        </small>

      </div>
    </div>

    <div class="tab-pane-action">
      <button type="button" v-if="currentIndex" @click.prevent="goPrevQuesStep()">
        <app-icon name="chevron-left" class="mr-2" />
        {{ $t('previous') }}
      </button>

      <div v-else></div>

      <button type="button" @click.prevent="goNextQuesStep">
        {{ $t('next') }}
        <app-icon name="chevron-right" class="ml-2" />
      </button>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

export default {
  name: "CandidateInputReceiveFields",
  mixins: [FormMixin],
  props: {
    title: { default: "" },
    formBody: {},
    currentIndex: {},
    errorObj: { default: () => ({}) }
  },
  data() {
    return {
      formData: this.formBody,
      passwordVisible: {
        password: false,
        password_confirmation: false
      }
    };
  },
  computed: {
    passwordMismatch() {
      const fields = this.formData?.fields || [];
      const pass = fields.find(f => f?.name?.key === "password");
      const confirm = fields.find(f => f?.name?.key === "password_confirmation");

      // validate only if both exist in this step
      if (!pass || !confirm) return false;

      // required -> both must be filled
      if (!pass.value || !confirm.value) return true;

      return (pass.value || "") !== (confirm.value || "");
    }
  },
  methods: {
    isPasswordField(item) {
      const key = item?.name?.key;
      return item?.type === "password" || key === "password" || key === "password_confirmation";
    },
    togglePasswordVisibility(key) {
      this.$set(this.passwordVisible, key, !this.passwordVisible[key]);
    },
    isReadonlyField(item) {
      return item?.name?.key === "login" || item?.readonly === true;
    },
    listGen(options, type, field) {
      const useLang = ["gender", "email"];

      if (!(type === "radio" || type === "checkbox" || type === "select")) return [];
      if (this.isUndefined(options) || options.length < 1) return [];

      return options.map(item => ({
        id: this.nameGen(item),
        value: useLang.includes(field?.name?.key) ? this.$t(item) : item
      }));
    },
    nameGen(name) {
      return _.snakeCase(_.lowerCase(name));
    },
    goNextQuesStep() {
      if (this.passwordMismatch) {
        if (this.$toastr?.e) this.$toastr.e(this.$t("passwords_do_not_match"));
        return;
      }
      this.$emit("next", this.formData);
    },
    goPrevQuesStep() {
      this.$emit("previous");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
